import { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import { getApi } from './index';
import { isStudentApp } from '../util/app-util';
import { hasAuthCookies } from '../util/auth-cookie-util';

const educatorAppAuthStrategy = hasAuthCookies()
  ? AuthStrategy.AUTH_TOKEN
  : AuthStrategy.HTTP_AUTHENTICATION;
const routePrefix = '/users/me';

const updateUserSetting = (type: string, data: any) => {
  return getApi(isStudentApp ? AuthStrategy.SESSION : educatorAppAuthStrategy).put(
    `${routePrefix}/settings/${type}`,
    { data }
  );
};

const putTourStep = (tour: Array<any>) => {
  return getApi(isStudentApp ? AuthStrategy.SESSION : educatorAppAuthStrategy).put(
    `${routePrefix}/tour`,
    { data: tour }
  );
};

export { updateUserSetting, putTourStep };
